// components/Composite/CardGrid/CardGrid.js
import PropTypes from 'prop-types';

/**
 * CardGrid — normalized grid section for index pages.
 * Gap is always gap-blocks (24px = L2 block level).
 * Columns controlled via `columns` prop.
 */
const CardGrid = ({
  items = [],
  children,
  emptyMessage = 'No items available',
  emptyDescription = 'Check back later for new content!',
  columns = 3,
  sectionWidth = 'section-full',
}) => {

  if (!items || items.length === 0) {
    return (
      <section className={`section ${sectionWidth}`}>
        <div className="section__inner">
          <div className="section__body">
            <div className="stack stack-normal block-align-center">
              <div className="text-section-title">{emptyMessage}</div>
              {emptyDescription && (
                <div className="text-body text-muted">{emptyDescription}</div>
              )}
            </div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section className={`section ${sectionWidth}`}>
      <div className="section__inner">
        <div className="section__body">
          <div className={`grid-${columns} gap-blocks`}>
            {items.map((item, index) => children(item, index))}
          </div>
        </div>
      </div>
    </section>
  );
};

CardGrid.propTypes = {
  items:            PropTypes.array,
  children:         PropTypes.func.isRequired,
  emptyMessage:     PropTypes.string,
  emptyDescription: PropTypes.string,
  columns:          PropTypes.oneOf([2, 3, 4, 5]),
  sectionWidth:     PropTypes.string,
};

export default CardGrid;